import { permissionCreate } from '@permissions';

const addVendorToWorkspace = permissionCreate('VENDORS_ADD_VENDOR_TO_WORKSPACE');

export const VENDORS = {
  [addVendorToWorkspace]: addVendorToWorkspace,
};

export default VENDORS;
